<template>
  <div
    class="stembus"
    :class="fadeClasses"
  >
    <img
      :src="require('@/assets/images/stemhok.gif')"
      alt=""
      draggable="false"
      class="image"
    />
    <div
      class="men"
      :style="{
        'background-image': `url(${require('@/assets/images/group-of-men.svg')})`
      }"
    ></div>
  </div>
</template>

<script>
import { fadeMixin } from '@/mixins'
import { TimelineMax, Power0 } from 'gsap'

export default {
  name: 'Stembus',
  mixins: [fadeMixin],
  watch: {
    done () {
      const scene = this.$scrollmagic.scene({
        triggerElement: '.stembus'
      })

      const timeline = new TimelineMax({ repeat: -1 })
        .to('.men', 5, {
          backgroundPosition: '-350px 0',
          ease: Power0.easeNone
        })

      this.$scrollmagic.addScene(
        scene.setTween(timeline)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.stembus {
  margin-top: 60px;
  position: relative;
  text-align: center;
  padding-bottom: 30px;
}

.image {
  width: 284px;
  height: 411px;
}

.men {
  position: absolute;
  bottom: 92px;
  width: 349px;
  height: 97px;
  background-position: 350px 0;
  background-repeat: no-repeat;
  left: 50%;
  transform: translateX(7px);
}
</style>
